import axios from '../axios'

// コース更新（担当講師/admin）
const putCourseApi = async (courseId, payload) => {
  return await axios.put(`api/lms/courses/${courseId}`, payload)
}

export default putCourseApi
